import React, { useState } from 'react';
import './PasswordInput.css';

/**
 * Password input with an eye toggle inside the field to show/hide the value.
 * Passes all other props (value, onChange, name, required, placeholder, etc.)
 * straight through to the underlying <input>, and forwards `className` so each
 * page keeps its own input styling.
 *
 * `wrapClassName` sets the width of the field's column so it matches sibling
 * inputs on that page (e.g. the email field). Defaults to full width.
 */
function PasswordInput({ className, wrapClassName, ...inputProps }) {
  const [show, setShow] = useState(false);

  return (
    <div className={`password-input-wrap${wrapClassName ? ` ${wrapClassName}` : ''}`}>
      <input
        {...inputProps}
        type={show ? 'text' : 'password'}
        className={className}
      />
      <button
        type="button"
        className="password-input-toggle"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Hide password' : 'Show password'}
        aria-pressed={show}
        tabIndex={0}
      >
        {show ? (
          // Eye-off icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2" strokeLinecap="round"
               strokeLinejoin="round" aria-hidden="true">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          // Eye icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2" strokeLinecap="round"
               strokeLinejoin="round" aria-hidden="true">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}

export default PasswordInput;
